/**
 * Enumeración para el tipo de filtro de calendario
 */
export enum FilterType {
  firstDay = 'firstDay',
  currentAndFollowing = 'currentAndFollowing'
}
